import React, {Component} from 'react';
import TextField from '@material-ui/core/TextField';
import Select from 'react-select';
import { FLOATING_COUNTRY_LABEL, 
    FLOATING_CITY_LABEL, NO_CONTENT_AVAILABLE, ALT_ICON, USER_DATA_UPDATE_NAME_SURNAME_OR_COMPANY_TITLE, FLOATING_NAME_SURNAME_OR_COMPANY_TITLE_LABEL, USER_DATA_UPDATE_COUNTRY_GET_EVENTS, USER_DATA_UPDATE_CITY } from '../../../../config/TextContent';
import {SLOVAK_COUNTRY_ID} from '../../../../config/Constants';
import {transformPropsWithLabelAndValue, onForeignObjectChange, transformObjectToTreeSelectObject,
    onChangeHelper} from '../../RegistrationModal/RegistrationModal/RegistrationModalHelper';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import UserDataUpdateModalSubmitButton from '../../UserDataUpdateModal/UserDataUpdateModal/UserDataUpdateModalSubmitButton';
import customReactSelectStyles from '../../../../config/ReactSelectStyle';

class RoleUserDataManagementModalPromoterContent extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            user: {
                name: props.user.user_data.name,
                city: props.user.user_data.city && props.user.user_data.city.hasOwnProperty('id') ? props.user.user_data.city.id : null,
                city_string: props.user.user_data.city_string,
                city_obj: transformObjectToTreeSelectObject(props.user.user_data.city),
                country: props.user.user_data.state && props.user.user_data.state.hasOwnProperty('id') ? props.user.user_data.state.id : null,
                country_obj: transformObjectToTreeSelectObject(props.user.user_data.state)
            },
            errors: props.errors ? props.errors : {},
        };
    }   

    componentDidMount(){
        this.setState({
            errors: this.props.errors,
        });
    }

    onNameChange = (event) => {
        const event_value = event.target.value;
        this.setState((prevState) => {
            let user = prevState.user;
            let errors = prevState.errors;
            user.name = event_value;
            errors.name = null;
            return {
                errors,
                user
            };
        });
    }

    onChange = (event, name = null) => {
        onChangeHelper(this, event, name);
    };

    onCountryChange = (selectedOption) => {
        onForeignObjectChange(this, selectedOption, 'country');
    }

    onCityChange = (selectedOption) => {
        onForeignObjectChange(this, selectedOption, 'city');
    }

    render() {
        return (
            <div>
                <div>
                    <div className="row user-data-management-modal__step">
                        <div className="row user-data-management-modal__step__header">
                            <div className="col-md-2 col-xs-2">
                                <img src={'/img/icons/numbers/1.svg'} alt={ALT_ICON}/>
                            </div>
                            <div className="col-md-10 col-xs-10">
                                <p>{USER_DATA_UPDATE_NAME_SURNAME_OR_COMPANY_TITLE}</p>                                         
                            </div>
                        </div>
                        <div className="row user-data-management-modal__step__body">
                            <div className="col-md-2 col-xs-2"></div>
                            <div className="col-md-10 col-xs-10">
                                <TextField
                                    name="name"
                                    required
                                    value={this.state.user.name}
                                    className={this.state.errors.name ? 'user-data-management-modal__step__body__element error-textfield' : 'user-data-management-modal__step__body__element'}
                                    label={this.state.errors.name ? this.state.errors.name : FLOATING_NAME_SURNAME_OR_COMPANY_TITLE_LABEL}
                                    placeholder="..."
                                    onChange={(event) => {this.onNameChange(event)}}
                                    autoComplete="off"
                                    autoCorrect="off"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row user-data-management-modal__step">
                        <div className="row user-data-management-modal__step__header">
                            <div className="col-md-2 col-xs-2">
                                <img src={'/img/icons/numbers/2.svg'} alt={ALT_ICON}/>
                            </div>
                            <div className="col-md-10 col-xs-10">
                                <p>{USER_DATA_UPDATE_COUNTRY_GET_EVENTS}</p>                                         
                            </div>
                        </div>
                        <div className="row user-data-management-modal__step__body">
                            <div className="col-md-2 col-xs-2"></div>
                            <div className="col-md-10 col-xs-10">
                                <div className={this.state.errors.country ? 'user-data-management-modal__step__body__element error-selectfield' : 'user-data-management-modal__step__body__element'}>
                                    <label className="required">{this.state.errors.genre ? this.state.errors.genre : FLOATING_COUNTRY_LABEL}</label>
                                    <Select
                                        styles={customReactSelectStyles}
                                        classNamePrefix="styled-tree-select"
                                        className="styled-tree-select"
                                        name="country"
                                        value={this.state.user.country_obj}
                                        onChange={(event) =>  {this.onCountryChange(event)}}
                                        options={this.props.countries}
                                        placeholder="..."
                                        noOptionsMessage={() => {return NO_CONTENT_AVAILABLE}}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row user-data-management-modal__step">
                        <div className="row user-data-management-modal__step__header">
                            <div className="col-md-2 col-xs-2">
                                <img src={'/img/icons/numbers/3.svg'} alt={ALT_ICON}/>
                            </div>
                            <div className="col-md-10 col-xs-10">
                                <p>{USER_DATA_UPDATE_CITY}</p>                                         
                            </div>
                        </div>
                        <div className="row user-data-management-modal__step__body">
                            <div className="col-md-2 col-xs-2"></div>
                            <div className="col-md-10 col-xs-10">
                                {(((this.state.user.country && this.state.user.country.hasOwnProperty('id')) ? this.state.user.country.id : this.state.user.country) === SLOVAK_COUNTRY_ID) ? (
                                    <div className={this.state.errors.city ? 'user-data-management-modal__step__body__element error-selectfield' : 'user-data-management-modal__step__body__element'}>
                                        <label className="required">{this.state.errors.city ? this.state.errors.city : FLOATING_CITY_LABEL}</label>
                                        <Select
                                            styles={customReactSelectStyles}
                                            classNamePrefix="styled-tree-select"
                                            className="styled-tree-select styled-tree-select-registration-modal"
                                            name="city"
                                            placeholder="..."
                                            value={this.state.user.city_obj}
                                            onChange={event => {this.onCityChange(event)}}
                                            options={this.props.cities}
                                            noOptionsMessage={() => {return NO_CONTENT_AVAILABLE}}
                                        />
                                    </div>
                                ) : (
                                    <TextField
                                        required
                                        name="city_string"
                                        value={this.state.user.city_string}
                                        className={this.state.errors.city_string ? 'user-data-management-modal__step__body__element error-textfield' : 'user-data-management-modal__step__body__element'}
                                        placeholder="..."
                                        onChange={event => {this.onChange(event)}}
                                        label={this.state.errors.city_string ? this.state.errors.city_string : FLOATING_CITY_LABEL}
                                        autoComplete="off"
                                        autoCorrect="off"
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <UserDataUpdateModalSubmitButton 
                        loading={this.props.loading}
                        errors={this.props.errors}
                        onSubmit={() => this.props.onSubmit(this.state.user)}
                    />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        countries: transformPropsWithLabelAndValue(state.countryReducer.countryList),
        cities: transformPropsWithLabelAndValue(state.citiesReducer.cityList),
    }
}

RoleUserDataManagementModalPromoterContent.propTypes = {
    loading: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    countries: PropTypes.array.isRequired,
    cities: PropTypes.array.isRequired,
    errors: PropTypes.object.isRequired
};

export default connect(mapStateToProps)(RoleUserDataManagementModalPromoterContent);
